import {Injectable} from "@angular/core";
import {DeleteHeaderComponent} from "@irb-common/components/grid/renderers/delete.header.component";
import {
  IrbAgSetColumnFilterComponent
} from "@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-set-column-filter/irb-ag-set-filter.component";
import {DropdownFilterRendererComponent} from "@irb-common/components/grid/renderers/dropdown-filter.cell.component";
import {IDropdownItem} from "@irb-common/models/dropdown.model";
import {DeleteCellComponent} from "@irb-common/components/grid/renderers/delete.cell.component";
import {
  ValidationTextBoxRendererComponent
} from "@irb-common/components/grid/renderers/validation-text-box-renderer.component";
import {
  DropdownSearchMultipleRendererComponent
} from "@irb-common/components/grid/renderers/dropdown-search-multiple.cell.component";


@Injectable({
  providedIn: "root"
})
export class ReportingInvoiceGridLayoutService {

  reportingTypes: Array<IDropdownItem> = [
    {value: "INDIVIDUAL_INVOICE", name: "Individual invoices"},
    {value: "MODEL_USAGE", name: "Model Usage"},
    {value: "AGGREGATED_INVOICE", name: "Aggregated invoices"}
  ];

  getFrameworkComponents(): any {
    return {
      "DeleteHeaderComponent": DeleteHeaderComponent,
      "DeleteCellComponent": DeleteCellComponent,
      "irbAgSetColumnFilterComponent": IrbAgSetColumnFilterComponent,
      "DropdownFilterRendererComponent": DropdownFilterRendererComponent,
      "ValidationTextBoxRendererComponent": ValidationTextBoxRendererComponent,
      "DropdownSearchMultipleRendererComponent": DropdownSearchMultipleRendererComponent
    };
  }

  getColumnDefs(parent: any) {
    return [
      {
        headerName: "",
        cellRenderer: "DeleteCellComponent",
        cellRendererParams: {
          message: "Delete this item?",
          proceed: parent.delete.bind(parent),
          cancel: parent.cancelDelete.bind(parent)
        },
        resizable: false,
        minWidth: 25,
        maxWidth: 25,
        width: 25,
        suppressColumnsToolPanel: true,
        lockPosition: true
      },
      {
        headerName: "AS Firm ID",
        field: "asFirmId",
        cellClass: "validationTextBoxCell",
        cellRenderer: "ValidationTextBoxRendererComponent",
        cellRendererParams: (_params: any) => {
          return {
            regExp: "^[0-9]+$",
            max: 15,
            onChange: (params: any, c: any) => {
              if (params.data.asFirmId !== c.value) {
                if (c.value.trim() !== '') {
                  parent.rememberRecordBeforeChange(params.data);
                  params.data.asFirmId = Number(c.value.trim());
                  params.api.redrawRows({rowNodes: [params.node]});
                  parent.onGridChange(params.data, params);
                } else {
                  parent.showEmptyErrorAlert('AS Firm ID', params);
                }
              }
            }
          };
        },
        suppressMovable: true,
        minWidth: 150,
        width: 170
      },
      {
        headerName: "MMC Reporting Master",
        field: "reportMasterAccount",
        cellClass: "validationTextBoxCell",
        cellRenderer: "ValidationTextBoxRendererComponent",
        cellRendererParams: (_params: any) => {
          return {
            max: 12,
            onChange: (params: any, c: any) => {
              if (params.data.reportMasterAccount !== c.value) {
                if (c.value.trim() !== '') {
                  parent.rememberRecordBeforeChange(params.data);
                  params.data.reportMasterAccount = c.value.trim();
                  params.api.redrawRows({rowNodes: [params.node]});
                  parent.onGridChange(params.data, params);
                } else {
                  parent.showEmptyErrorAlert('MMC Reporting Master', params);
                }
              }
            }
          };
        },
        suppressMovable: true,
        minWidth: 150
      },
      {
        headerName: "Reporting Request",
        field: "reportTypes",
        suppressMovable: true,
        cellClass: 'dropdownSearchMultipleCell dropdown-grid-mmc-reporting',
        cellRenderer: 'DropdownSearchMultipleRendererComponent',
        cellRendererParams: (params: any) => {
          return {
            defaultValue: this.getReportingType(params.data.reportTypes),
            canEdit: false,
            showAsAll: true,
            enableEmptySearchTerm: true,
            values: this.reportingTypes,
            enableHiddenSearchResults: false,
            isAllSelected: this.getReportingType(params.data.reportTypes).length === this.reportingTypes.length,
            showApplyButton: true,
            onApply: (params: any, changedReportTypes: Array<IDropdownItem>) => {
              const types = changedReportTypes.map((tp: any) => tp.value);
              parent.rememberRecordBeforeChange(params.data);
              params.data.reportTypes = types;
              params.api.redrawRows({rowNodes: [params.node]});
              parent.onGridChange(params.data, params);
            }
          };
        },
        width: 280
      },
      {
        headerName: "User ID of Requestor",
        field: "requestorUserId",
        cellClass: "validationTextBoxCell",
        cellRenderer: "ValidationTextBoxRendererComponent",
        cellRendererParams: (_params: any) => {
          return {
            max: 30,
            onChange: (params: any, c: any) => {
              if (params.data.requestorUserId !== c.value) {
                if (c.value.trim() !== '') {
                  parent.rememberRecordBeforeChange(params.data);
                  params.data.requestorUserId = c.value.trim();
                  params.api.redrawRows({rowNodes: [params.node]});
                  parent.onGridChange(params.data, params);
                } else {
                  parent.showEmptyErrorAlert('User ID of Requestor', params);
                }
              }
            }
          };
        },
        suppressMovable: true
      }
    ];
  }

  getReportingType(type: Array<string>) {
    let typesArray: Array<string> = type;
    let selectedTypes: Array<IDropdownItem> = [];
    typesArray.forEach(tp => {
      let reportType: IDropdownItem = this.reportingTypes.find((x: IDropdownItem) => x.value === tp);
      selectedTypes.push(reportType);
    });
    // let reportType: IDropdownItem = this.reportingTypes.find((x: IDropdownItem) => x.value === type);
    return selectedTypes;
  }

}
